/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Editor_Col_AvailableInputs */

const vi_packaging_editor_col_available = /** @type {(inputs: Packaging_Editor_Col_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn`)
};

/**

* @param {Packaging_Editor_Col_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_editor_col_available = /** @type {((inputs?: Packaging_Editor_Col_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Editor_Col_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_editor_col_available(inputs)
});